import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">{aboutData.title}</h2>
          <p className="text-foreground-500 text-sm md:text-base">了解我们，了解每一颗瓜背后的故事</p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200 p-6 md:p-10">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-8">
              {aboutData.content}
            </p>
            <div className="grid grid-cols-3 gap-6">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading font-black text-2xl md:text-4xl text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}